import React from "react"
import ReactMarkdown from "react-markdown"
import WizardBanner from "./WizardBanner"
import SingleChoiceButtons from "./SingleChoiceButtons"
import RadioGroupQuestion from "./RadioGroupQuestion"
import SelectDropdownQuestion from "./SelectDropdownQuestion"
import GradePicker from "./GradePicker"
import ChecklistQuestion from "./ChecklistQuestion"
import KeepOrAcceptChecklist from "./KeepOrAcceptChecklist"
import SummaryCard from "./SummaryCard"

const WIDGETS_BY_TYPE = {
  single_choice: SingleChoiceButtons,
  radio_group: RadioGroupQuestion,
  select_dropdown: SelectDropdownQuestion,
  grade_picker: GradePicker,
  checklist: ChecklistQuestion,
  keep_or_accept_checklist: KeepOrAcceptChecklist,
  summary_card: SummaryCard,
}

// Renders a Program Matrix AI Coach wizard message: the plain-English content (same
// markdown rendering as a normal bot bubble) followed by the type-specific interactive
// widget, if any. `banner` messages are non-interactive and render only the pill.
const WizardMessage = ({ msg, onRespond }) => {
  if (msg.type === "banner") {
    return <WizardBanner wizardMeta={msg.wizardMeta} />
  }

  const Widget = WIDGETS_BY_TYPE[msg.type]

  return (
    <div className="wizard-message">
      <ReactMarkdown style={{ marginTop: "10px" }}>{msg.content}</ReactMarkdown>
      {Widget && (
        <Widget
          wizardMeta={msg.wizardMeta}
          answered={!!msg.answered}
          onRespond={onRespond}
        />
      )}
    </div>
  )
}

export default WizardMessage
